/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * A lifecycle operation that can be performed on the deployment in its current
 *
 * @remarks
 * state, given its status, environment, and whether it is the current
 * deployment.
 */
export const DeploymentAction = {
  Promote: "promote",
  Rollback: "rollback",
  Stop: "stop",
  Start: "start",
} as const;
/**
 * A lifecycle operation that can be performed on the deployment in its current
 *
 * @remarks
 * state, given its status, environment, and whether it is the current
 * deployment.
 */
export type DeploymentAction = ClosedEnum<typeof DeploymentAction>;

/** @internal */
export const DeploymentAction$inboundSchema: z.ZodNativeEnum<
  typeof DeploymentAction
> = z.nativeEnum(DeploymentAction);
